/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from 'react'
import { Row, Element } from "trux"
import { TopStatCard } from "../../components/TopStatCard"
import "./PlayerDetailsPanelRowBaseball.css"

export const PlayerDetailsPanelRowBaseball = ({stats, playerCount, isTraceFamilyGame}) => {

	return (
		<Row>
			<TopStatCard
				statValue={
					stats.reachedSafely ? stats.reachedSafely.toFixed(0) : 0
				}
				statRank={stats.reachedSafely_rank}
				playerCount={playerCount}
				statTitle="# Reached Safely"
				isTraceFamilyGame={isTraceFamilyGame}
			/>
			<TopStatCard
				statValue={
					stats.atBat ? stats.atBat.toFixed(0) : 0
				}
				statRank={stats.atBat_rank}
				playerCount={playerCount}
				statTitle="# At Bats"
				isTraceFamilyGame={isTraceFamilyGame}
			/>
			<TopStatCard
				statValue={
					stats.defensivePlay ? stats.defensivePlay.toFixed(0) : 0
				}
				statRank={stats.defensivePlay_rank}
				playerCount={playerCount}
				statTitle="# Defensive Play"
				isTraceFamilyGame={isTraceFamilyGame}
			/>
			<Element className="TopStatCard">
				<Element className="Stat">
					<Element tag='span' className="positions">{stats.positions.join(", ")}</Element>
				</Element>
				<Element className="StatLabel">
					# Positions
				</Element>
			</Element>
		</Row>
	)
}